import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { featureMapping, ProductOfferingBenefit } from '@mkp/shared/models';
import { TranslateModule } from '@ngx-translate/core';
import { BenefitFlagPipe, ProductTooltipComponent } from '@mkp/product/ui';
import { AssetComponent } from '@mkp/shared/ui-asset';

@Component({
  selector: 'mkp-product-table-row-header-feature',
  templateUrl: './product-table-row-header-feature.component.html',
  styleUrl: './product-table-row-header-feature.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AssetComponent, BenefitFlagPipe, ProductTooltipComponent, TranslateModule],
})
export class ProductTableRowHeaderFeatureComponent {
  @Input()
  set benefit(benefit: ProductOfferingBenefit) {
    const { title, description } = featureMapping[benefit];
    if (title) {
      this.translation = title;
    }
    if (description) {
      this.tooltipText = description;
    }
    this.currentBenefit = benefit;
  }
  @Input() showTooltip = false;

  currentBenefit: ProductOfferingBenefit | undefined;
  translation: string | undefined;
  tooltipText: string | undefined;
}
